import type { JSX } from "react";
import { shallow } from "zustand/shallow";
import {
  ColorTheme,
  resolveTheme,
  useAppSettingsStore,
} from "@/store/appSettings.store";
import { ThemeToggleSwitch } from "./ThemeToggleSwitch";

export const ThemeToggle = ({ label }: { label?: string }): JSX.Element => {
  const { theme, toggleTheme } = useAppSettingsStore(
    (state) => ({
      theme: state.theme,
      toggleTheme: state.toggleTheme,
    }),
    shallow,
  );

  return (
    <ThemeToggleSwitch
      checked={resolveTheme(theme) === ColorTheme.Dark}
      label={label}
      onChange={toggleTheme}
    />
  );
};
